import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { problemManagementStatusValues } from '../../../models/static-list-data.service'
@Component({
  selector: 'app-task-status-static-lookup',
  templateUrl: './app-task-status-static-lookup.component.html',
  styleUrls: ['./app-task-status-static-lookup.component.css']
})
export class AppTaskStatusStaticLookupComponent implements OnInit {
  taskStatusList = [];
  taskStatusTypeSelected = [];
  isMultipleSelected = true;
  whereObj = {};


  @Input() set resetData(isClear) {
    if (isClear) {
      this.taskStatusTypeSelected = [];
    }
  }
  @Output() getTaskStatusObj: EventEmitter<any> = new EventEmitter;

  @Input()
  set setTaskStatusObj(params) {
    this.taskStatusList = [];
    // this.clearTaskStatus();
    this.whereObj = this.whereObj && Object.keys(this.whereObj).length ? this.whereObj : {};
  }

  constructor() { }

  ngOnInit() {
    this.taskStatusList = problemManagementStatusValues;
    const preselected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';
    this.taskStatusTypeSelected = (preselected && preselected['problemTaskStatuses']) ? preselected['problemTaskStatuses'] : [];
    this.onTaskStatusChange();
  }
  onTaskStatusChange() {
    this.getTaskStatusObj.emit(this.taskStatusTypeSelected);
  }
  clearTaskStatus() {
    this.taskStatusTypeSelected = [];
    this.getTaskStatusObj.emit([]);
  }
}

